


<div class="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
  <header class="mb-auto">
    <div>
      <div class="container">

      </div>
    </div>
  </header>

  <main class="px-3 py-3">


      <h1 *ngIf="nombreProveedor">¡Hola, <span class="fw-bolder">{{ nombreProveedor }}!</span> </h1>
    <div class="container" *ngIf="ordenIsValid && saldoPendiente !== 0 ; else completeOrder">

    <p style="color:var(--primary-color);" *ngIf="!ordenIsClosed; else elseBlock" class="fs-3 fw-bold">Sube tu factura correspondiente a la orden de compra #{{codigoOrden}}</p>
      <p style="color:var(--primary-color);" class="fs-3  fw-bold">Saldo pendiente por subir: <span class="fw-bold">${{ saldoPendiente }} </span></p>


    </div>
    <ng-template #elseBlock>
      <h1 >¡Parece que tu orden de compra ha sido cerrada! </h1>
      <p  class="lead">
        Si tienes alguna duda, no dudes en contactar a nuestro equipo de compras. ¡Estamos aquí para ayudarte!</p>
    </ng-template>

    <ng-template #completeOrder>
      <h3 >¡Ya no necesitas subir más documentos. Tu saldo a subir es {{ saldoPendiente }}! 🚀 </h3>
    </ng-template>

    <div class="container " *ngIf="!ordenIsClosed && ordenIsValid && saldoPendiente !==0 ">
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label for="formFileXML" class="form-label">Archivo XML <i class="bi bi-filetype-xml"></i> <i *ngIf="checkXML" style="font-size: 25px; color: mediumseagreen" class=" bi bi-check-all"></i></label>
            <input #inputXML [disabled]="isDisabled" class="form-control" type="file" id="formFileXML" accept=".xml" (change)="setTrueXML($event); capturarArchivo($event, 'xml', codigoOrden);  extractTotal(($event))" >
          </div>

        </div>
        <div class="col-6">
          <div class="mb-3">
            <label for="formFilePDF" class="form-label">Archivo PDF <i class="bi bi-filetype-pdf"></i>            <i *ngIf="checkPDF" style="font-size: 25px; color: mediumseagreen" class="fs- 1 bi bi-check-all"></i>
            </label>
            <input #inputPDF [disabled]="isDisabled" class="form-control" type="file" id="formFilePDF" accept=".pdf" (change)="setTruePDF($event); capturarArchivo($event, 'pdf', codigoOrden)" >
          </div>

        </div>

        <div class="row-12 justify-content-center  ">
          <div class="container justify-content-end">
            <button [disabled]="isDisabled" (click)="sendFiles()" class="btn btn-lg btn-outline-secondary  fw-normal fs-6  ">Subir Archivos <i class="bi bi-cloud-arrow-up"></i></button>
          </div>

        </div>
      </div>
    </div>
  </main>


  <div class="row-12 justify-content-center mt-1  ">
    <div class="container justify-content-start">
      <button *ngIf="pagosAutomaticos > 0" class="btn btn-outline-secondary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
        Ver facturas subidas <i class="bi bi-file-earmark-text"></i>
      </button>
    </div>
    <div class="container justify-content-start p-3">
      <button (click)="refreshPage()" class="btn btn-outline-secondary" type="button" >
        Actualizar <i class="bi bi-arrow-clockwise"></i>
      </button>
    </div>

  </div>


  <footer class="mt-5 w-100 text-white-10">
    <p class=" fs-6 fw-bold " style="visibility: hidden" >En caso de que el nombre mostrado no corresponda al suyo o identifique algún error, le solicitamos amablemente que se comunique con nuestro equipo de soporte a la brevedad. Estaremos encantados de asistirle para resolver cualquier inconveniente.</p>
    <p class="fw-bold"><a  style="color:var(--primary-color);" routerLink="/" >Medilink</a></p>
  </footer>
</div>



<app-notifications/>





<div *ngIf="pagosAutomaticos > 0" class="offcanvas offcanvas-start w-50" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasExampleLabel">Documentos Subidos</h5>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body text-start">
    <div>
      Lista de documentos que previamente ha subido, en caso de que necesite revisarlos, descargarlos o eliminarlos para reemplazarlos.
    </div>
      <table class="table">
        <thead>
        <tr >
          <th scope="col">Valor de la Factura</th>
<!--          <th scope="col">Estado</th>-->
          <th scope="col">Numero de la Factura</th>
          <th scope="col" *ngIf="!ordenIsClosed">Eliminar</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let list of listDocuments">
          <th scope="row">${{list.valorFactura}}</th>
<!--          <th scope="row"><span class="badge text-bg-primary">Pago Aprobado</span></th>-->
          <td>{{ list.numero_factura }}</td>
          <td *ngIf="!ordenIsClosed"><button (click)="deleteDocument(hashedPassword, codigoOrden, list.id)"><i class="bi bi-trash"></i></button></td>
        </tr>
        <tr>
          <th colspan="3">${{totalSuma}} - Total de las facturas subidas</th>
        </tr>

        </tbody>
      </table>
  </div>



  <div class="container">
    <button class="my-2"  data-bs-dismiss="offcanvas">Subir Documentos  <i class="bi bi-cloud-upload"></i></button>
  </div>
</div>
